// App.js
import React, { useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import firebase from 'firebase/compat/app';
import 'firebase/compat/messaging';
import { requestForToken } from './firebase';
import { getUrls } from '../src/api/apiurls.js';
var pushNConfigs = getUrls().pushNotifications;
// Nabeel
// const firebaseConfig = {
//   apiKey: "AIzaSyC9L7ZfzMBm_VF4pvKcQl6tCAraKIbBpbA",
//   authDomain: "ebuyings-3a9b1.firebaseapp.com",
//   projectId: "ebuyings-3a9b1",
//   storageBucket: "ebuyings-3a9b1.appspot.com",
//   messagingSenderId: "521126371798",
//   appId: "1:521126371798:web:4b5c8f2d1e46b8aec74477",
//   measurementId: "G-6SBD9TG2ZC"
// };
//Ahsan
// const firebaseConfig = {
//   apiKey: "AIzaSyCpv7czGbSObCNiPgYC030adCdPXUQoU2g",
//   authDomain: "ebuyings-28f79.firebaseapp.com",
//   projectId: "ebuyings-28f79",
//   storageBucket: "ebuyings-28f79.appspot.com",
//   messagingSenderId: "397458844239",
//   appId: "1:397458844239:web:c8a9e5349080cccbbed83a",
//   measurementId: "G-6K3JVWCVF2"
// };

const firebaseConfig = {
  apiKey: pushNConfigs.apiKey,
  authDomain: pushNConfigs.authDomain,
  projectId: pushNConfigs.projectId,
  storageBucket: pushNConfigs.storageBucket,
  messagingSenderId: pushNConfigs.messagingSenderId,
  appId: pushNConfigs.appId,
  measurementId: pushNConfigs.measurementId,
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
const messaging = firebase.messaging();

function App() {
  useEffect(() => {
    // Request permission and get the token
    requestForToken();
 
    // Handle foreground messages
    messaging.onMessage((payload) => {
      const { body } = payload.notification;//title
      // toast.info(<p>${title} - ${body}</p>);
      toast.info(<div dangerouslySetInnerHTML={{ __html: `${body}` }} />,  {
        autoClose: false,
        closeButton: true,
        position: "top-right" 
      });
    });
  }, []);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const tenantloc = urlParams.get("tenantloc");
    console.log('tenantloc',tenantloc);
    if (tenantloc) {
      if (tenantloc &&  tenantloc != "general") {
        localStorage.setItem("tenantWebId", tenantloc);
      } else {
        localStorage.setItem("tenantWebId", null);
      }
    }
  }, []);

  return (
    <div className="App">
      {/* Your app content */}
      {/* <ToastContainer position="top-right" autoClose={5000} /> */}
      <ToastContainer />
    </div>
  );
}

export default App;
